import { render, staticRenderFns } from "./order-detail-template.vue?vue&type=template&id=5d9ee0c6&scoped=true&%23default=true"
import script from "./order-detail-template.vue?vue&type=script&lang=js"
export * from "./order-detail-template.vue?vue&type=script&lang=js"
import style0 from "./order-detail-template.vue?vue&type=style&index=0&id=5d9ee0c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9ee0c6",
  null
  
)

export default component.exports